import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LcsApiService } from '@lcs/shared/api';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs/operators';
import { ThemeService } from '../themes/theme.service';
import { Themes } from '../themes/themes.enum';
import * as SiteLayoutActions from './site-layout.actions';

@Injectable()
export class SiteLayoutEffects {
   changeTheme = createEffect(
      () => {
         return this.actions$.pipe(
            ofType(SiteLayoutActions.customerViewClick),
            tap((action) => {
               this.themeService.setTheme(action.checked ? Themes.Customer : Themes.Default);
            })
         );
      },
      { dispatch: false }
   );

   constructor(
      private actions$: Actions,
      private apiService: LcsApiService,
      private store: Store,
      private router: Router,
      private themeService: ThemeService
   ) {}
}
